export function scrollToFirstSelectedRow() {
	let selectedNodes = gridSettings.api.getSelectedNodes();
	let selectedNode = selectedNodes[0];

	if (typeof selectedNode != 'undefined') {
		gridSettings.api.ensureIndexVisible(selectedNode.rowIndex, 'top');
	}
}
